export default __webpack_public_path__ + "images/e9f18a812550e02b60469e0782a98a90.svg";